exports.default = {
  'build_success': '创建已完成',
  'build_failed': '创建失败',
  'build_version': '版本: ',
  'click_to_detail': '点击查看详情',
  'permission_box_title': '任务完成后通知我',
  'permission_box_msg': '任务完成后会通过浏览器通知你',
  'permission_box_btn': '启用通知',
  'permission_not_granted': '您已关闭了浏览器通知权限, 请在浏览器设置中手动开启',
  'permission_denied': '您拒绝了浏览器通知权限',
  'bill_permission_box_title': '订单完成后通知我',
  'bill_permission_box_msg': '订单完成后会通过浏览器通知你'
}
